import { BackgroundType, SubSectionData } from "../LandingSubSection/types";

import SubSection from "../LandingSubSection";

export default function SubSectionList({
  data,
  firstSectionBackgroundType,
  className,
}: {
  data: SubSectionData[];
  firstSectionBackgroundType: BackgroundType;
  className?: string;
}) {
  return (
    <>
      {data.map((v, index) => (
        <SubSection
          key={index}
          {...v}
          sequence={index + 1}
          firstSectionBackgroundType={firstSectionBackgroundType}
          className={`${className ?? "landing-sub-section"}-${index + 1}`}
        />
      ))}
    </>
  );
}
